(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["levalmier-instagram"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lv-instagram-strip')) {
  customElements.define('lv-instagram-strip', class extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.lv-instagram__stage');
      this.track = this.querySelector('.lv-instagram__track');
      this.items = Array.from(this.querySelectorAll('.lv-instagram__post'));
      this.button = this.querySelector('.lv-instagram__toggle');
      if (!this.stage || !this.track || !this.items.length) return;

      this.speedScale = Number(this.dataset.speedScale) || 1;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.states = new Map();
      this.width = 0;
      this.height = 0;
      this.paused = false;
      this.visible = true;
      this.frame = 0;
      this.lastTime = 0;
      this.resizeRaf = 0;

      this.tick = this.tick.bind(this);
      this.measure = this.measure.bind(this);
      this.sync = this.sync.bind(this);

      this.track.classList.add('is-animated');
      this.measure(true);

      // Reveal the images. requestAnimationFrame gives the smooth fade-in
      // when the page is actually being painted; the timeout is a hard
      // guarantee, because rAF is suspended while a tab sits in the
      // background - without it, a page opened in a background tab would
      // keep the images at opacity 0 forever. reveal() is idempotent.
      const reveal = () => this.items.forEach(item => item.classList.add('is-ready'));
      requestAnimationFrame(reveal);
      setTimeout(reveal, 400);

      if (this.button) {
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          this.button.textContent = this.paused ? this.button.dataset.play : this.button.dataset.pause;
          this.sync();
        });
      }

      // Debounce + coalesce resize notifications into a single rAF, and
      // ignore small height-only deltas in measure() below - iOS Safari
      // fires ResizeObserver repeatedly while its address bar shows/hides
      // during scroll, and reacting to every one of those was clamping
      // image positions and making them visibly jump ("snap") mid-scroll.
      this.resizeObserver = new ResizeObserver(() => {
        if (this.resizeRaf) return;
        this.resizeRaf = requestAnimationFrame(() => {
          this.resizeRaf = 0;
          this.measure(false);
        });
      });
      this.resizeObserver.observe(this.stage);

      this.intersectionObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      });
      this.intersectionObserver.observe(this);

      this.motion.addEventListener('change', () => this.sync());
      document.addEventListener('visibilitychange', this.sync);

      this.sync();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      document.removeEventListener('visibilitychange', this.sync);
    }

    measure(initial) {
      const rect = this.stage.getBoundingClientRect();
      const newWidth = rect.width;
      const newHeight = rect.height;

      if (!initial) {
        // Ignore mobile-Safari toolbar show/hide noise: those only ever
        // change the viewport HEIGHT by a small amount and never the
        // width, so skip re-laying out for that case entirely.
        const widthChanged = Math.abs(newWidth - this.width) > 1;
        const heightChanged = Math.abs(newHeight - this.height) > 40;
        if (!widthChanged && !heightChanged) return;
      }

      this.width = newWidth;
      this.height = newHeight;
      if (!this.width || !this.height) return;

      const count = this.items.length;
      const columns = Math.max(1, Math.ceil(Math.sqrt(count)));

      this.items.forEach((item, index) => {
        const w = item.offsetWidth || this.width / columns;
        const h = item.offsetHeight || w;
        const maxX = Math.max(0, this.width - w);
        const maxY = Math.max(0, this.height - h);
        let state = this.states.get(item);

        if (!state) {
          const cellW = maxX / columns || 1;
          const cellH = maxY / columns || 1;
          const cx = index % columns;
          const cy = Math.floor(index / columns) % Math.max(1, columns);
          const x = Math.min(maxX, Math.max(0, cx * cellW + Math.random() * cellW));
          const y = Math.min(maxY, Math.max(0, cy * cellH + Math.random() * cellH));
          const angle = Math.random() * Math.PI * 2;
          const speed = (26 + Math.random() * 30) * this.speedScale;
          state = {
            x,
            y,
            w,
            h,
            angle,
            speed,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed,
          };
          this.states.set(item, state);
          // Assign a STABLE stacking order once, at first layout, instead
          // of continuously re-sorting by vertical position every frame.
          // A persistent z-index is what actually removes the abrupt
          // "snap to front/back" that happened whenever two images'
          // paths crossed.
          item.style.zIndex = String(index + 1);
        } else {
          state.w = w;
          state.h = h;
          state.x = Math.min(state.x, maxX);
          state.y = Math.min(state.y, maxY);
        }

        item.style.transform = 'translate3d(' + state.x + 'px, ' + state.y + 'px, 0)';
      });
    }

    canMove() {
      return !this.motion.matches &&
        this.dataset.autoplay !== 'false' &&
        !this.paused &&
        this.visible &&
        !document.hidden &&
        this.width > 0 &&
        this.height > 0;
    }

    sync() {
      if (this.canMove()) {
        if (!this.frame) {
          this.lastTime = 0;
          this.frame = requestAnimationFrame(this.tick);
        }
      } else if (this.frame) {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
      }
    }

    tick(time) {
      if (!this.canMove()) {
        this.frame = 0;
        return;
      }
      this.frame = requestAnimationFrame(this.tick);
      const delta = Math.min((time - (this.lastTime || time)) / 1000, 0.05);
      this.lastTime = time;

      // Continuous, gentle steering instead of an instant random re-aim
      // every few seconds: the heading drifts a little every frame, so
      // the path curves smoothly and never visibly "turns on a dime".
      const turnRate = 0.6; // radians/sec of max drift

      this.items.forEach(item => {
        const state = this.states.get(item);

        state.angle += (Math.random() - 0.5) * turnRate * delta;
        state.vx = Math.cos(state.angle) * state.speed;
        state.vy = Math.sin(state.angle) * state.speed;

        state.x += state.vx * delta;
        state.y += state.vy * delta;

        const maxX = Math.max(0, this.width - state.w);
        const maxY = Math.max(0, this.height - state.h);

        // Reflect the heading itself (not just the raw velocity) so the
        // continuous-angle model above stays consistent after a bounce.
        if (state.x <= 0) {
          state.x = 0;
          state.angle = Math.PI - state.angle;
        } else if (state.x >= maxX) {
          state.x = maxX;
          state.angle = Math.PI - state.angle;
        }

        if (state.y <= 0) {
          state.y = 0;
          state.angle = -state.angle;
        } else if (state.y >= maxY) {
          state.y = maxY;
          state.angle = -state.angle;
        }

        item.style.transform = 'translate3d(' + state.x + 'px, ' + state.y + 'px, 0)';
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levalmier-video-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lv-video-products')) {
  customElements.define('lv-video-products', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.lv-video-products__track');
      this.video = this.querySelector('video');
      this.arrows = this.querySelector('.lv-video-products__arrows');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.drag = null;
      this.suppressClick = false;
      if (this.video) this.video.controls = false;
      this.syncVideo = () => {
        if (!this.video) return;
        if (this.visible && !document.hidden && !this.motion.matches) this.video.play().catch(() => {});
        else this.video.pause();
      };
      this.measure = () => {
        if (this.arrows) this.arrows.hidden = !this.track || this.track.scrollWidth <= this.track.clientWidth + 1;
      };
      this.querySelectorAll('[data-previous],[data-next]').forEach(button => {
        button.addEventListener('click', () => {
          if (!this.track) return;
          const card = this.track.querySelector('.lv-video-products__card');
          const step = (card?.getBoundingClientRect().width || this.track.clientWidth) + (parseFloat(getComputedStyle(this.track).gap) || 0);
          this.track.scrollBy({ left: button.hasAttribute('data-next') ? step : -step, behavior: this.motion.matches ? 'instant' : 'smooth' });
        }, options);
      });
      this.track?.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track?.addEventListener('pointerdown', event => {
        this.suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.drag = { id: event.pointerId, x: event.clientX, left: this.track.scrollLeft, moved: false };
      }, options);
      window.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const delta = event.clientX - this.drag.x;
        if (!this.drag.moved && Math.abs(delta) < 6) return;
        this.drag.moved = true;
        this.suppressClick = true;
        this.track.classList.add('is-dragging');
        event.preventDefault();
        this.track.scrollLeft = this.drag.left - delta;
      }, options);
      const release = event => {
        if (!this.drag || (event.pointerId !== undefined && event.pointerId !== this.drag.id)) return;
        this.drag = null;
        this.track.classList.remove('is-dragging');
      };
      window.addEventListener('pointerup', release, options);
      window.addEventListener('pointercancel', release, options);
      window.addEventListener('blur', release, options);
      this.track?.addEventListener('click', event => {
        if (this.suppressClick && event.detail !== 0) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        }
      }, { ...options, capture: true });
      this.motion.addEventListener('change', this.syncVideo, options);
      document.addEventListener('visibilitychange', this.syncVideo, options);
      this.resize = new ResizeObserver(this.measure);
      if (this.track) this.resize.observe(this.track);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.syncVideo();
      });
      this.observer.observe(this);
      this.measure();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
      this.drag = null;
      this.track?.classList.remove('is-dragging');
      this.video?.pause();
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lv-announcement-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStrip(root) {
      (root || document).querySelectorAll('[data-lv-strip]').forEach(function (list) {
        if (list.dataset.bound) return;
        list.dataset.bound = 'true';
        var items = list.querySelectorAll('.lv-strip__item');
        if (items.length < 2) return;
        var i = 0;
        setInterval(function () {
          if (window.matchMedia('(min-width: 1440px)').matches) return;
          items[i].classList.remove('is-active');
          i = (i + 1) % items.length;
          items[i].classList.add('is-active');
        }, 3500);
      });
    }
    initStrip();
    document.addEventListener('shopify:section:load', function (e) { initStrip(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lv-editorial-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  var desktop = window.matchMedia('(min-width: 750px)');

  function play(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function startHeroVideo(video) {
    if (video.dataset.lvStarted) return;
    if (video.hasAttribute('data-desktop-only') && !desktop.matches) return;
    video.dataset.lvStarted = 'true';
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.removeAttribute('controls');
    video.addEventListener('playing', function () { video.classList.add('is-playing'); }, { once: true });
    video.addEventListener('pause', function () { if (!document.hidden) play(video); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) play(video); });
    ['touchstart', 'click', 'scroll'].forEach(function (ev) {
      window.addEventListener(ev, function () { play(video); }, { once: true, passive: true });
    });
    video.autoplay = true;
    video.addEventListener('canplay', function () { play(video); }, { once: true });
    video.src = video.dataset.src;
    play(video);
  }

  function initHeroVideos() {
    document.querySelectorAll('.lv-refined-home__video[data-src]').forEach(startHeroVideo);
  }

  // Load the video only after the page (and the hero picture) has finished loading.
  function afterLoad() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(initHeroVideos, { timeout: 1500 });
    else window.setTimeout(initHeroVideos, 200);
  }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });

  // A phone rotated or a window widened past the breakpoint can still start the video.
  if (desktop.addEventListener) desktop.addEventListener('change', initHeroVideos);
  document.addEventListener('shopify:section:load', initHeroVideos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lv-seen-on-you"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lv-seen-on-you')) {
    customElements.define('lv-seen-on-you', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-lv-soy-track]');
        this.prev = this.querySelector('[data-lv-soy-prev]');
        this.next = this.querySelector('[data-lv-soy-next]');
        if (!this.track) return;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.videos = [...this.querySelectorAll('video')];
        this.videos.forEach((v) => { v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); });
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
              const v = e.target;
              if (e.isIntersecting && e.intersectionRatio > 0.5) {
                if (v.preload === 'none') v.preload = 'metadata';
                if (!this.reduce) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
              } else if (!v.paused) {
                v.pause();
              }
            });
          }, { threshold: [0, 0.5, 1] });
          this.videos.forEach((v) => this.io.observe(v));
        }
        const step = () => {
          const card = this.track.querySelector('.lv-soy__card');
          return card ? card.getBoundingClientRect().width + 16 : this.track.clientWidth;
        };
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          const overflow = max > 0;
          this.prev.hidden = !overflow || this.track.scrollLeft <= 2;
          this.next.hidden = !overflow || this.track.scrollLeft >= max;
        };
        this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: this.reduce ? 'auto' : 'smooth' }));
        this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: this.reduce ? 'auto' : 'smooth' }));
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.update) window.removeEventListener('resize', this.update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
